<template>
    <div class="container">
        <br/>
        <h2 align="center">Naujas klientas</h2><br/>
        <div class="form-group p-0">
            <form method="post" id="register_form">
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link tab1 active_tab1" style="border:1px solid #ccc" id="list_address_details">Kliento
                            adresas</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link tab1" id="list_personal_details" style="border:1px solid #ccc">Asmens
                            duomenys</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link tab1" id="list_contact_details" style="border:1px solid #ccc">Kontaktai</a>
                    </li>
                </ul>
                <div class="tab-content" style="margin-top:16px;">
                    <div class="tab-pane show active" id="address_details">
                        <div class="card card-default">
                            <div class="card-header">Kliento adresas</div>
                            <div class="card-body">
                                <div class="form-group">

                                    <input id="contract_address"
                                           v-model="address"
                                           class="form-control"
                                           placeholder="Ivesti adresą">


                                </div>

                                <div class="form-group">
                                    <label for="roof_type">Stogo tipas</label>
                                    <select id="roof_type"
                                            v-model="roof_type_id"
                                            class="form-control">
                                        <option value="">Rinktis...</option>
                                        <option :value="roof.id" v-for="roof in roof_types">{{ roof.name }}</option>
                                    </select>


                                </div>
                                <br/>


                                <div align="center">

                                    <button type="button" name="btn_address_details" id="btn_address_details"
                                            @click="checkAddress"
                                            class="btn btn-info btn-lg">Sekantis
                                    </button>
                                </div>
                                <br/>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="personal_details">
                        <div class="card card-default">
                            <div class="card-header">Asmens duomenys</div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>Vardas Pavardė</label>
                                    <input type="text" v-model="name" id="name" class="form-control"
                                           @keyup="loadCustomers()"
                                           @focusout="customers = null"
                                    />
                                    <div v-if="customers" class="dropdown">
                                        <ul>
                                            <li v-for="c in this.customers">{{ c }}</li>
                                        </ul>
                                    </div>

                                    <span id="error_first_name" class="text-danger"></span>
                                </div>

                                <div class="form-group">
                                    <label>PIN</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">
                                                <input type="checkbox" id="do_not_check_ak" title="Įvesti vėliau">
                                            </div>
                                        </div>
                                        <input type="text" v-model="pin" class="form-control"/>

                                    </div>
                                    <span id="error_code" class="text-danger"></span>

                                </div>

                                <br/>
                                <div align="center">
                                    <button type="button"
                                            @click="backToAddress"
                                            id="previous_btn_personal_details" class="btn btn-default btn-lg">Anstesnis
                                    </button>
                                    <button type="button" id="btn_personal_details"
                                            @click="checkPerson"
                                            class="btn btn-info btn-lg">Sekantis
                                    </button>
                                </div>
                                <br/>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="contact_details">
                        <div class="card card-default">
                            <div class="card-header">Kontaktai</div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>Mob. telefono numeris</label>
                                    <input type="text" v-model="phone" id="mobile" class="form-control"/>
                                    <span id="error_mobile" class="text-danger"></span>
                                </div>
                                <div class="form-group">
                                    <label>El. paštas</label>
                                    <input v-model="email" id="email" class="form-control"/>
                                    <span id="error_email" class="text-danger"></span>
                                </div>

                                <br/>
                                <div align="center">
                                    <button type="button" name="previous_btn_contact_details"
                                            @click="backToPersonal"
                                            id="previous_btn_contact_details" class="btn btn-default btn-lg">Ankstesnis
                                    </button>
                                    <button type="button" name="btn_contact_details" id="btn_contact_details"
                                            @click="createCustomer"
                                            class="btn btn-success btn-lg">Kurti užsakymą
                                    </button>
                                </div>
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "NewCustomer",
    data() {
        return {
            address: 'Ofisas',
            name: 'NoName',
            pin: '0',
            phone: '+370',
            email: '-',
            roof_type_id: '',
            roof_types: '',
            customers: null
        }
    },
    methods: {
        checkAddress() {
            if(this.address.length > 0 && this.roof_type_id > 0) {
                $('#list_address_details').removeClass('active active_tab1');
                $('#address_details').removeClass('active show');
                $('#list_personal_details').addClass('active active_tab1');
                $('#personal_details').addClass('active show');
            }
        },
        checkPerson() {
            if(this.name.length > 0 && this.pin.length > 0) {
                $('#personal_details').removeClass('active show');
                $('#list_personal_details').removeClass('active_tab1');
                $('#list_contact_details').addClass('active_tab1');
                $('#contact_details').addClass('active show');
            }
        },
        backToPersonal() {
            $('#personal_details').addClass('active show');
            $('#list_personal_details').addClass('active_tab1');
            $('#list_contact_details').removeClass('active');
            $('#contact_details').removeClass('active show');
        },
        backToAddress() {
            $('#list_address_details').addClass('active');
            $('#address_details').addClass('active show');
            $('#list_personal_details').removeClass('active_tab1');
            $('#personal_details').removeClass('active show');
        },
        createCustomer() {
            console.log(this._data);
            axios
                .post('customer', this._data)
                .then(response => {
                    console.log(response.data);
                    window.location.replace('customer/' + response.data.id)
                })
                .catch(error => {
                    let array = {'msg': error.response.data.message};
                    axios.post('/mail_error', array).then(res => {
                        console.log(res.data);
                    });
                    window.location.replace('/404');
                });
        },
        loadCustomers() {
            let rr = [];
            axios.get('/get_customers').then(res => {
                for(let index = 0; index < res.data.length; index++) {
                    var str = res.data[index].name + ' ' + res.data[index].address + ' ' + res.data[index].phone;
                    if(str.indexOf(this.name) !== -1) {

                        if(rr.length > 10) {
                            break;
                        }
                        rr.push(str);
                    }

                }
                this.customers = rr;
            });
            return this.customers;
        },
    },
    mounted() {
        axios.get('/roof_types')
            .then(response => {
                this.roof_types = response.data;
            })
            .catch(error => {
                let array = {'msg': error.response.data.message};
                axios.post('/mail_error', array).then(res => {
                    console.log(res.data);
                });
                window.location.replace('/404');
            });
    }
}
</script>

<style scoped>

.box {
    width: 800px;
    margin: 0 auto;
}

.active_tab1 {
    background-color: #fff !important;
    color: #333 !important;
    font-weight: 600 !important;
}

.tab1 {
    background-color: #f5f5f5;
    color: #333;
    cursor: not-allowed;
}

.has-error {
    border-color: #cc0000;
    background-color: #ffff99;
}

/* Style to position the dropdown below the input */
.dropdown {
    position: relative;
    display: inline-block;
}


.dropdown ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 99;
    width: calc(100vw - 100px);
}

.dropdown li {
    padding: 8px;
    border-bottom: 1px solid #ccc;
}

.dropdown li:last-child {
    border-bottom: none;
}

</style>
